import axios from 'axios';
import { PAID_FEATURE_IDX } from '@/constants';

const PAYMENT_API = '/api/payment';

const URL_SUCCESS = 'payment-success';
const URL_FAIL = 'payment-fail';

export default class PaymentService {
  constructor() {}

  getCheckoutSession(productId = 1, countryCode: string) {
    const requestBody = {};
    const reqUrl = '?productId=' + productId + '&urlSuccess=' + URL_SUCCESS + '&urlCancel=' + URL_FAIL + '&countryCode=' + countryCode;
    return new Promise<any>((resolve, reject) => {
      axios
        .post(PAYMENT_API + '/get-checkout-session' + reqUrl, requestBody)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  changePlan(productIdAfter: number) {
    if (!productIdAfter) return;
    const reqUrl = '?&productIdAfter=' + productIdAfter;
    return new Promise<any>((resolve, reject) => {
      axios
        .post(PAYMENT_API + '/change-product-of-subscription' + reqUrl)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  getPaidHistory() {
    return new Promise<any>((resolve, reject) => {
      axios.get(PAYMENT_API + '/get-paidplan-history').then(res => resolve(res));
    });
  }

  addTrialForUser() {
    return new Promise<any>((resolve, reject) => {
      axios.get(PAYMENT_API + '/trial', {}).then(res => resolve(res));
    });
  }

  getTrialingHistory() {
    return new Promise<any>((resolve, reject) => {
      axios.get(PAYMENT_API + '/get-trialing-history').then(res => resolve(res));
    });
  }

  getCreditAmountBeforeChange(productIdAfter: number) {
    if (!productIdAfter) return;
    const reqUrl = '?&productIdAfter=' + productIdAfter;
    return new Promise<any>((resolve, reject) => {
      axios.post(PAYMENT_API + '/get-credit-amount-before-change' + reqUrl).then(res => resolve(res));
    });
  }

  getCheckoutSessionResult(sessionId: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(PAYMENT_API + '/get-checkout-session-result?sessionId=' + sessionId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
